"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var BlDropdown_1 = __importDefault(require("../BlDropdown"));
var PostViewSelectOptions_1 = require("../../../constants/PostViewSelectOptions");
var BlSwitch_1 = __importDefault(require("../BlSwitch"));
var BlTextInput_1 = __importDefault(require("../BlTextInput"));
var BlRadioGroup_1 = __importDefault(require("../BlRadioGroup"));
var BlCheckboxGroup_1 = __importDefault(require("../BlCheckboxGroup"));
var BlDropzone_1 = __importDefault(require("../BlDropzone"));
var BlSingleDropzone_1 = __importDefault(require("../BlSingleDropzone"));
var BlDateTime_1 = __importDefault(require("../BlDateTime"));
var TextAreaEditor_1 = __importDefault(require("../TextAreaEditor"));
var PhoneInputList_1 = __importDefault(require("../../Account/Settings/PhoneInputList"));
var BlCheckbox_1 = __importDefault(require("../BlCheckbox"));
var BlAddressPicker_1 = __importDefault(require("../BlAddressPicker"));
var MonthlyPriceInput_1 = __importDefault(require("../BlRentalPrice/MonthlyPriceInput"));
var DailyPriceInput_1 = __importDefault(require("../BlRentalPrice/DailyPriceInput"));
var PostingMortgage_1 = require("../../../constants/PostingMortgage");
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var DeveloperParentEntityFileUpload_1 = __importDefault(require("../DeveloperParentEntityFileUpload"));
var translationHelper_1 = require("../../../helpers/translationHelper");
var fieldOptions_1 = require("../../../helpers/fieldOptions");
var i18n_1 = __importDefault(require("../../../i18n"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var FormComponentFields = function (_a) {
    var extractPath = _a.extractPath, extractValue = _a.extractValue, cb = _a.cb, field = _a.field, fieldName = _a.fieldName, formikProps = _a.formikProps, onMediaUpload = _a.onMediaUpload, onSingleMediaUpload = _a.onSingleMediaUpload, onSingleMediaRemove = _a.onSingleMediaRemove, removeParentEntityMedia = _a.removeParentEntityMedia, removeEntityMedia = _a.removeEntityMedia, onMediaReorder = _a.onMediaReorder, disabled = _a.disabled, index = _a.index, mortgageId = _a.mortgageId, addRemovedMortgageId = _a.addRemovedMortgageId, isDisableWhenRental = _a.isDisableWhenRental, setEditors = _a.setEditors, translateText = _a.translateText, clearTextEditor = _a.clearTextEditor;
    return (react_1.default.createElement(react_1.default.Fragment, null, resolveField(extractPath, extractValue, cb, field, fieldName, formikProps, onMediaUpload, onSingleMediaUpload, onSingleMediaRemove, removeParentEntityMedia, removeEntityMedia, onMediaReorder, disabled, index, mortgageId, addRemovedMortgageId, isDisableWhenRental, setEditors, translateText, clearTextEditor)));
};
exports.default = FormComponentFields;
function resolveField(extractPath, extractValue, cb, field, fieldName, formikProps, onMediaUpload, onSingleMediaUpload, onSingleMediaRemove, removeParentEntityMedia, removeEntityMedia, onMediaReorder, disabled, index, mortgageId, addRemovedMortgageId, isDisableWhenRental, setEditors, translateText, clearTextEditor) {
    var _this = this;
    var _a, _b;
    if (onMediaUpload === void 0) { onMediaUpload = function () { return Promise.resolve(undefined); }; }
    if (onSingleMediaUpload === void 0) { onSingleMediaUpload = function () { return Promise.resolve(undefined); }; }
    if (onSingleMediaRemove === void 0) { onSingleMediaRemove = function () { return Promise.resolve(undefined); }; }
    if (removeParentEntityMedia === void 0) { removeParentEntityMedia = function () { return Promise.resolve(undefined); }; }
    if (removeEntityMedia === void 0) { removeEntityMedia = function () {
        return Promise.resolve(undefined);
    }; }
    if (onMediaReorder === void 0) { onMediaReorder = function () { return undefined; }; }
    if (disabled === void 0) { disabled = false; }
    var component = field.component, options = field.options;
    var t = react_i18next_1.useTranslation('common').t;
    var handleMediaReOrdering = function (from, to) {
        var arr = __spreadArray([], extractValue());
        var el = arr[from];
        arr.splice(from, 1);
        arr.splice(to, 0, el);
        formikProps.setFieldValue(extractPath(), arr);
    };
    var handleMediaOnChange = function (files) { return __awaiter(_this, void 0, void 0, function () {
        var media;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onMediaUpload(files)];
                case 1:
                    media = _a.sent();
                    // If successfully uploaded
                    if (media) {
                        formikProps.setFieldValue(extractPath(), media);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    switch (component) {
        case 'Select': {
            return (react_1.default.createElement(BlDropdown_1.default, { value: extractValue(), onChange: function (event, data) {
                    formikProps.setFieldValue(extractPath(), data.value);
                }, 
                // Table options bring their own labels and property types;
                // config options keep the i18n key lookup.
                options: options
                    .filter(function (o) {
                    var _a;
                    return fieldOptions_1.isOptionForType(o, (_a = formikProps.values.initial_info) === null || _a === void 0 ? void 0 : _a.property_type);
                })
                    // "label" would render as a chip next to the item in Semantic UI;
                    // "labels"/"propertyTypes" are already used above and must not reach the DOM.
                    .map(function (_a, index) {
                    var label = _a.label, labels = _a.labels, propertyTypes = _a.propertyTypes, o = __rest(_a, ["label", "labels", "propertyTypes"]);
                    return (__assign(__assign({}, o), { key: index, value: o.text, text: labels
                            ? fieldOptions_1.pickOptionLabel(labels, i18n_1.default.language)
                            : t("FIELD_OPTIONS." + o.text) }));
                }), selection: true, clearable: true, placeholder: t('DROPDOWN.PLACEHOLDER'), disabled: disabled ||
                    (formikProps.values.deal === GeneralSettings_1.DEAL_TYPES.RENT &&
                        isDisableWhenRental), selectOnBlur: false }));
        }
        case 'BankSelect': {
            return (react_1.default.createElement(BlDropdown_1.default, { value: extractValue(), onChange: function (event, data) {
                    if (!data.value) {
                        formikProps.setFieldValue('mortgage[' + String(index) + '].name', '');
                        formikProps.setFieldValue('mortgage[' +
                            String(index) +
                            '].min_prepayment', '');
                        formikProps.setFieldValue('mortgage[' +
                            String(index) +
                            '].mortgage_programs', []);
                        formikProps.setFieldValue('mortgage[' + String(index) + '].min_percent', '');
                        formikProps.setFieldValue('mortgage[' + String(index) + '].max_duration', '');
                        addRemovedMortgageId &&
                            addRemovedMortgageId(mortgageId);
                    }
                    else {
                        formikProps.setFieldValue(extractPath(), data.value);
                    }
                    formikProps.setTouched({}, false);
                }, options: PostViewSelectOptions_1.BankSelectOptionValues.map(function (o, index) { return ({
                    key: index,
                    value: o.text,
                    text: t(o.text),
                    image: o.image,
                }); }), selection: true, clearable: true, placeholder: t('DROPDOWN.PLACEHOLDER'), disabled: disabled, selectOnBlur: false, className: styles_module_scss_1.default.bank_select_options }));
        }
        case 'MultipleChoice': {
            return (react_1.default.createElement(BlDropdown_1.default, { value: extractValue() || [], onChange: function (event, data) {
                    formikProps.setFieldValue(extractPath(), data.value);
                }, options: options.map(function (o, index) { return (__assign(__assign({}, o), { key: index, value: o.text, text: t("FIELD_OPTIONS." + o.text) })); }), selection: true, placeholder: t('DROPDOWN.PLACEHOLDER'), disabled: PostingMortgage_1.DisabledMortgageInputFields.includes(field.label)
                    ? !((_a = formikProps.values.mortgage[String(index)].name) === null || _a === void 0 ? void 0 : _a.length)
                    : disabled, selectOnBlur: false, multiple: true, className: styles_module_scss_1.default.multiple_choice }));
        }
        case 'Switch': {
            var value = extractValue();
            return (react_1.default.createElement(BlSwitch_1.default, { className: styles_module_scss_1.default.full_width, checked: value === 'yes', onChange: function (event, data) {
                    formikProps.setFieldValue(extractPath(), data.checked ? 'yes' : 'no');
                } }));
        }
        case 'TextInput': {
            return (react_1.default.createElement(BlTextInput_1.default, { autoComplete: "off", type: field.type || '', fieldName: fieldName, value: extractValue(), isNaturalNumber: !!field.isNaturalNumber, isNonNegativeNumber: !!field.isNonNegativeNumber, isNumberCommaFormat: field.isNumberCommaFormat, maxLength: field.maxLength, placeHolders: field.placeHolder, onChange: function (value) {
                    formikProps.setFieldValue(extractPath(), value);
                    if (cb) {
                        cb(value);
                    }
                }, disabled: PostingMortgage_1.DisabledMortgageInputFields.includes(field.label)
                    ? !((_b = formikProps.values.mortgage[String(index)].name) === null || _b === void 0 ? void 0 : _b.length)
                    : disabled }));
        }
        case 'RadioGroup': {
            return (react_1.default.createElement(BlRadioGroup_1.default, { value: extractValue(), options: options, isNaturalNumber: !!field.isNaturalNumber, isNonNegativeNumber: !!field.isNonNegativeNumber, maxLength: field.maxLength, onChange: function (label) {
                    formikProps.setFieldValue(extractPath(), label);
                }, hasInput: true, freeDesignCheckbox: field.freeDesignCheckbox || null }));
        }
        case 'CheckboxGroup': {
            return (react_1.default.createElement(BlCheckboxGroup_1.default, { options: options.filter(function (o) {
                    var _a;
                    return fieldOptions_1.isOptionForType(o, (_a = formikProps.values.initial_info) === null || _a === void 0 ? void 0 : _a.property_type);
                }), checked: extractValue() || [], isRadioBox: field.isRadioBox, onChange: function (checked) {
                    formikProps.setFieldValue(extractPath(), checked);
                }, disabled: PostingMortgage_1.DisabledMortgageInputFields.includes(field.label) &&
                    formikProps.values.mortgage[String(index)].name
                    ? !formikProps.values.mortgage[String(index)].name
                        .length
                    : disabled }));
        }
        case 'FileUpload': {
            return (react_1.default.createElement(BlDropzone_1.default, { values: extractValue(), onChange: function (files) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, handleMediaOnChange(files)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }, onRemoved: function (id) { return __awaiter(_this, void 0, void 0, function () {
                    var media;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, removeEntityMedia(id)];
                            case 1:
                                media = _a.sent();
                                // If successfully removed
                                if (media) {
                                    formikProps.setFieldValue(extractPath(), media);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, onReordering: function (from, to) {
                    handleMediaReOrdering(from, to);
                }, onReordered: function (from, to) {
                    onMediaReorder(from, to);
                } }));
        }
        case 'PersonalParentEntityFileUpload': {
            return (react_1.default.createElement(BlDropzone_1.default, { values: extractValue(), onChange: function (files) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, handleMediaOnChange(files)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }, onRemoved: function (id) { return __awaiter(_this, void 0, void 0, function () {
                    var media;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, removeParentEntityMedia(id)];
                            case 1:
                                media = _a.sent();
                                if (media) {
                                    formikProps.setFieldValue(extractPath(), media);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, onReordering: function (from, to) {
                    handleMediaReOrdering(from, to);
                }, onReordered: function (from, to) {
                    onMediaReorder(from, to);
                } }));
        }
        case 'BuildingFileUpload': {
            return (react_1.default.createElement(DeveloperParentEntityFileUpload_1.default, { values: extractValue(), onChange: function (files, buildingMediaType) { return __awaiter(_this, void 0, void 0, function () {
                    var media;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, onMediaUpload(files, buildingMediaType)];
                            case 1:
                                media = _a.sent();
                                // If successfully uploaded
                                if (media) {
                                    formikProps.setFieldValue(extractPath(), media);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, onRemoved: function (id) { return __awaiter(_this, void 0, void 0, function () {
                    var media;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, removeParentEntityMedia(id)];
                            case 1:
                                media = _a.sent();
                                // If successfully removed
                                if (media) {
                                    formikProps.setFieldValue(extractPath(), media);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, onReordering: function (from, to) {
                    var arr = __spreadArray([], extractValue());
                    var el = arr[from];
                    arr.splice(from, 1);
                    arr.splice(to, 0, el);
                    formikProps.setFieldValue(extractPath(), arr);
                }, onReordered: function (from, to) {
                    onMediaReorder(from, to);
                }, errors: formikProps.errors }));
        }
        case 'SingleFileUpload': {
            return (react_1.default.createElement(BlSingleDropzone_1.default, { value: extractValue(), onChange: function (file) { return __awaiter(_this, void 0, void 0, function () {
                    var media;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, onSingleMediaUpload(file, field.type)];
                            case 1:
                                media = _a.sent();
                                // If successfully uploaded
                                if (media) {
                                    formikProps.setFieldValue(extractPath(), media);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, onRemoved: function (id) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, onSingleMediaRemove(id, field.type)];
                            case 1:
                                _a.sent();
                                formikProps.setFieldValue(extractPath(), null);
                                return [2 /*return*/];
                        }
                    });
                }); } }));
        }
        case 'DateTime': {
            var value = extractValue();
            var props = {};
            if (field.props.min) {
                var minValue = extractValue(field.props.min);
                if (minValue) {
                    props.minDate = minValue;
                }
            }
            if (field.props.max) {
                var maxValue = extractValue(field.props.max);
                if (maxValue) {
                    props.maxDate = maxValue;
                }
            }
            return (react_1.default.createElement(BlDateTime_1.default, __assign({ selected: value && new Date(value), onChange: function (date, event) {
                    formikProps.setFieldValue(extractPath(), date);
                } }, props)));
        }
        case 'TextArea': {
            var path = extractPath();
            var value = extractValue();
            var editorLanguage = translationHelper_1.textEditorLangMapper(path.split('.')[1]);
            return (react_1.default.createElement(TextAreaEditor_1.default, { value: value, path: path, editorLanguage: editorLanguage, formikProps: formikProps }));
        }
        case 'PhoneInput': {
            return (react_1.default.createElement(PhoneInputList_1.default, { contacts: extractValue(), onAddEmpty: function (contacts) {
                    formikProps.setFieldValue(extractPath(), contacts);
                }, onChange: function (i, contact) {
                    formikProps.setFieldValue(extractPath() + "." + i, contact);
                }, onRemove: function (contacts) {
                    formikProps.setFieldValue("" + extractPath(), contacts);
                } }));
        }
        case 'Checkbox': {
            var value = extractValue();
            return (react_1.default.createElement(BlCheckbox_1.default, { checked: value === '1' || value === true, onChange: function (event, data) {
                    formikProps.setFieldValue(extractPath(), data.checked);
                } }));
        }
        case 'AddressPicker': {
            return (react_1.default.createElement(BlAddressPicker_1.default, { addressData: extractValue().addressData, location: extractValue().location, stateId: extractValue().stateId, districtId: extractValue().districtId, onSave: function (data) {
                    formikProps.setFieldValue(extractPath(), data);
                } }));
        }
        case 'MonthlyPriceInput': {
            return (react_1.default.createElement(MonthlyPriceInput_1.default, { monthlyPrice: extractValue(), onChange: function (value) {
                    formikProps.setFieldValue(extractPath(), value);
                }, formikProps: formikProps }));
        }
        case 'DailyPriceInput': {
            return (react_1.default.createElement(DailyPriceInput_1.default, { dailyPrice: extractValue(), onChange: function (value) {
                    formikProps.setFieldValue(extractPath(), value);
                }, formikProps: formikProps }));
        }
    }
}
